import { useContext, useEffect, useRef, useState, useMemo, useCallback } from 'react';
//import clsx from 'clsx';
import { Button, Loading } from '@appkit4/react-components';
import { DropdownButton } from '@appkit4/react-components/dropdown';
import { Tooltip } from '@appkit4/react-components/tooltip';
//import { Checkbox } from '@appkit4/react-components/checkbox';
import EnhancedSandpackRenderer from '@components/Sandpack/EnhancedSandpackRenderer';
import EmptySessionError from '@components/EmptySessionError';
import GenerationErrorOverlay from '@components/GenerationErrorOverlay';
import { ModificationOptions, SessionContext } from '@contexts/SessionProvider';
import NoDataSet from '../../assets/images/no-data-set.svg';
import styles from './Session.module.scss';
import { useSearchParams } from 'react-router-dom';
import {
    getMessagesBySessionId,
    getProjectFiles,
    getDownloadUrl,
    getAllSessions,
    getSharedSessions,
    abortActiveStream,
} from '@config/getSessionApis';
import { UserContext } from '@contexts/UserProvider';
import GeneratingOverlay from '@components/GeneratingOverlay/GeneratingOverlay';
import useStreamCompletion from '../../hooks/useStreamCompletion';
import { DepsMap, DesignSystems, TemplateVersion, preprocessSessionMessages } from '@utils/index';
import ShareModal from '@components/ShareModal/ShareModal';
import RemoveUserModal from '@components/RemoveUserModal/RemoveUserModal';
import CursorInstructionsModal from '@components/CursorInstructionsModal';
import { ShareUser } from '@contexts/SessionProvider';
import { SANDBOX_BUNDLER_URL } from '@config/sandbox';
// import ErrorSandpack from '@components/ErrorSandpack/ErrorSandpack';
//import ConfirmModal from '../../components/ConfirmModal/ConfirmModal';
import './Session.scss';

const EmptyModificationOptions: ModificationOptions = {
    componentType: '',
    dataComponentFile: '',
    dataComponentStartLine: '',
    dataComponentName: '',
    elementContent: '',
    elementOuterHTML: '',
    elementTagName: '',
};
// const themes = [
//     {
//         name: 'Blue',
//         backgroundColor: '#415385',
//     },
//     {
//         name: 'Orange',
//         backgroundColor: '#D04A02',
//     },
//     {
//         name: 'Green',
//         backgroundColor: '#26776D',
//     },
//     {
//         name: 'Pink',
//         backgroundColor: '#D93954',
//     },
//     {
//         name: 'Red',
//         backgroundColor: '#E0301E',
//     },
//     {
//         name: 'Black',
//         backgroundColor: '#000000',
//     },
// ];

const Session = () => {
    const {
        attachFile,
        currentSource,
        isChatCollapsed,
        isNewSession,
        isSandboxLoading,
        designSystem,
        templateVersion,
        showCodeStream,
        // showCodeEditor,
        devModeActive,
        currentChatSessionId,
        sessionId,
        isSessionOwner,
        firstPrompt,
        isGenerateComplete,
        // sandpackErrors,
        setSessionId,
        setIsNewSession,
        setIsSandboxLoading,
        setIsChatCollapsed,
        setCurrentSource,
        setDesignSystem,
        setTemplateVersion,
        setHistory,
        setThread,
        setShowCodeStream,
        setFirstPrompt,
        // setShowCodeEditor,
        setCurrentHistoryCommit,
        setDevModeActive,
        setStreamMessagesConsumer,
        setStreamMessageProvider,
        setModificationOptions,
        setCurrentChatSessionId,
        setIsGenerateComplete,
        setCurrentGenerationId,
        //currentGenerationId,
        setIsTargetActive,
        isTargetActive,
        setSessionOwnerEmail,
        thread,
        setAutoFixPrompt,
        generationError,
        setGenerationError,
        generationStatus,
        setGenerationStatus,
        setToolStatus,
    } = useContext(SessionContext);
    const { userEmail } = useContext(UserContext);

    // Drive stream completion detection (replaces StreamingCodePanel's built-in logic)
    useStreamCompletion();

    const selectedElemRef = useRef<HTMLElement | null>(null);
    // const [devModeActive, setDevModeActive] = useState(false);
    const [isTargetButtonEnabled, setIsTargetButtonEnabled] = useState(false);
    const [hasSessionDataError, setHasSessionDataError] = useState(false);
    // const [activeTheme, setActiveTheme] = useState(0);

    const [initialFiles, setIniitialFiles] = useState({});

    // Network monitoring during generation
    useEffect(() => {
        const handleOffline = () => {
            console.log('Network went offline');
            // If generation is in progress, trigger error
            if (!isGenerateComplete) {
                console.log('Generation interrupted by network disconnection');
                setGenerationError({
                    message: 'Network connection lost during code generation.',
                    error: { code: 'ERR_NETWORK', message: 'Network disconnected' },
                    prompt: firstPrompt || 'Generation in progress',
                    timestamp: Date.now(),
                });
                setIsGenerateComplete(true);
                setShowCodeStream(false);
                setGenerationStatus(null);
                setStreamMessagesConsumer([]);
                setStreamMessageProvider([]);
            }
        };

        window.addEventListener('offline', handleOffline);
        return () => window.removeEventListener('offline', handleOffline);
    }, [
        isGenerateComplete,
        firstPrompt,
        setGenerationError,
        setGenerationStatus,
        setIsGenerateComplete,
        setShowCodeStream,
        setStreamMessagesConsumer,
        setStreamMessageProvider,
    ]);
    const [searchParams] = useSearchParams();
    const sessionIdParam = searchParams.get('sessionId') || '';
    const designSystemParam: DesignSystems = (searchParams.get('designSystem') as DesignSystems) || '';
    const templateVersionParam: TemplateVersion = (searchParams.get('templateVersion') as TemplateVersion) || 'v2';
    const [shareModalVisible, setShareModalVisible] = useState(false);
    const [removeUserModalVisible, setRemoveUserModalVisible] = useState(false);
    const [cursorInstructionsVisible, setCursorInstructionsVisible] = useState(false);
    const [enableFullScreen, setEnableFullScreen] = useState(false);
    const [userRemove, setUserRemove] = useState({} as ShareUser);
    const defaultInitialFiles =
        templateVersionParam === 'v2'
            ? {
                  '/App.tsx': {
                      code: "import React from 'react';\nimport { CircularProgress, Box } from '@mui/material';\nconst App: React.FC = () => {\nreturn (\n<Box sx={{width: '100vw',height: '100vh',display: 'flex',justifyContent: 'center',alignItems: 'center',}}>\n<CircularProgress />\n</Box>\n);\n};\nexport default App;",
                  },
              }
            : {
                  '/App.js': {
                      code: "import '@appkit4/styles/appkit.min.css';\nimport '@appkit4/react-components/dist/styles/appkit4-react.min.css';\nimport { Loading } from '@appkit4/react-components';\nfunction App() {\nreturn (\n<div style={{width: '100vw',height: '100vh',display: 'flex',justifyContent: 'center',alignItems: 'center',}}>\n<Loading loadingType='linear' indeterminate={true} compact={false}></Loading>\n</div>\n);\n}\nexport default App;",
                  },
                  '/index.js': {
                      code: 'import React from "react";\nimport ReactDOM from "react-dom/client";\nimport App from "./App";\n\nconst root = ReactDOM.createRoot(document.getElementById("root"));\nroot.render(<App />);',
                  },
              };

    const handleReceiveMessage = (event: any) => {
        const { data } = event;
        if (data.type === 'rc') {
            if (data.inspPath) {
                const parts = data.inspPath.split(':');
                const dataComponentFile = parts[0] || '';
                const dataComponentStartLine = parts[1] || '';
                let dataComponentName = '';
                let dataComponentColumn = '';

                if (parts.length > 3) {
                    dataComponentColumn = parts[2] || '';
                    dataComponentName = parts.slice(3).join(':');
                } else if (parts.length === 3) {
                    if (/^\d+$/.test(parts[2])) {
                        dataComponentColumn = parts[2];
                    } else {
                        dataComponentName = parts[2];
                    }
                }

                const rawInnerHtml = typeof data.innerHTML === 'string' ? data.innerHTML : '';
                const textContent = rawInnerHtml.trim();
                const sanitizedHTML = textContent;

                const nextModificationOptions = {
                    dataComponentFile: `src/${dataComponentFile}`,
                    dataComponentName,
                    dataComponentStartLine: dataComponentColumn
                        ? `${dataComponentStartLine}:${dataComponentColumn}`
                        : dataComponentStartLine,
                    componentType: data.componentType,
                    elementContent: textContent,
                    elementOuterHTML: sanitizedHTML,
                    elementTagName: dataComponentName || '',
                };
                setModificationOptions(nextModificationOptions);
            }
        }
        if (data.type === 'initialized') {
            setIsSandboxLoading(true);
            setEnableFullScreen(false);
        }
        if (data.type === 'success') {
            setIsSandboxLoading(false);
            setEnableFullScreen(true);
        }
    };
    //const [showLeaveConfirmModal, setShowLeaveConfirmModal] = useState(false);
    // const leaveBlocker = useBlocker(({ currentLocation, nextLocation }) => {
    //     const isShow = currentLocation.pathname !== nextLocation.pathname;
    //     console.log('blocker',isShow)
    //     setShowLeaveConfirmModal(isShow);

    //     return isShow;
    // });
    // const handleCancelLeaveConfirm = () => {
    //     setShowLeaveConfirmModal(false);

    //     // if (leaveBlocker?.reset) {
    //     //     leaveBlocker.reset();
    //     // }
    // };
    // const handleConfirmLeaveConfirm = () => {
    //     setShowLeaveConfirmModal(false);
    //     window.removeEventListener('message', handleReceiveMessage);
    //     setStreamMessagesConsumer([]);
    //     setStreamMessageProvider([]);
    //     setCurrentChatSessionId(-1);
    //     setShowCodeStream(false);
    //     setModificationOptions(EmptyModificationOptions);
    //     setIsGenerateComplete(true);
    //     setIsTargetActive(false);
    //     // if (leaveBlocker?.proceed) {
    //     //     leaveBlocker.proceed();
    //     // }
    // };
    // const LeaveConfirm = () => {
    //     if (leaveBlocker.state === 'blocked') {
    //         return (
    //             <ConfirmModal
    //                 isShow={showLeaveConfirmModal}
    //                 onCancel={handleCancelLeaveConfirm}
    //                 onConfirm={handleConfirmLeaveConfirm}></ConfirmModal>
    //         );
    //     }
    // };

    useEffect(() => {
        const fetchProjectFiles = async (thread: any[]) => {
            const lastAnswer = thread[thread.length - 1][1]; // Get the last answer
            const response: any = await getProjectFiles(
                lastAnswer.chatSessionId,
                lastAnswer.commitId,
                designSystem,
                templateVersion
            ); // Wait for the API call to finish
            const projectFiles = response.resultObject;
            const source = {
                payload: {
                    files: projectFiles.files,
                },
            };
            setCurrentChatSessionId(lastAnswer.chatSessionId);
            setIniitialFiles(projectFiles.files);
            setCurrentSource(source);
            setCurrentHistoryCommit(lastAnswer.commitId);
        };

        const fetchSessionOwner = async () => {
            try {
                const mySessionsResult = await getAllSessions(userEmail);
                const mySessions = mySessionsResult.resultObject || [];
                const ownSession = mySessions.find((session: any) => session.sessionId === sessionIdParam);

                if (ownSession) {
                    setSessionOwnerEmail(ownSession.email || '');
                    return;
                }

                const sharedSessionsResult = await getSharedSessions(userEmail);
                const sharedSessions = sharedSessionsResult.resultObject || [];
                const sharedSession = sharedSessions.find((session: any) => session.sessionId === sessionIdParam);

                if (sharedSession) {
                    setSessionOwnerEmail(sharedSession.email || '');
                }
            } catch (error) {
                console.error('Error fetching session owner:', error);
            }
        };

        const fetchMessages = async () => {
            setSessionId(sessionIdParam);
            setDesignSystem(designSystemParam);
            setTemplateVersion(templateVersionParam);
            console.log('sessionIdParam', sessionIdParam);
            setHasSessionDataError(false); // Reset error state
            await fetchSessionOwner(); // Fetch session owner email
            const historialMessages = await getMessagesBySessionId(userEmail, sessionIdParam);
            const historialMessagesResult = historialMessages.resultObject;
            if (historialMessagesResult && historialMessagesResult.length) {
                const activeSession = preprocessSessionMessages(historialMessagesResult);
                setHistory(activeSession);
                setThread(activeSession);
                setHasSessionDataError(false);
                if (activeSession.length > 0) {
                    fetchProjectFiles(activeSession);
                }
            } else {
                // Empty resultObject - could be:
                // 1. New session (never generated)
                // 2. Generation stopped before completion
                // 3. Actual error (session doesn't exist)
                console.warn('Session has no messages (empty resultObject)');

                // Try to retrieve stored prompt for this session
                const storedPromptKey = `rapidcraft-prompt-${sessionIdParam}`;
                const storedPrompt = localStorage.getItem(storedPromptKey);

                if (storedPrompt) {
                    console.log('Found stored prompt for session:', storedPrompt);
                    // This indicates a generation was attempted but may have been stopped
                    // Don't show error - just empty state
                    setHasSessionDataError(false);
                } else {
                    // No stored prompt and no messages - could be a new session or actual error
                    // Check if this is from a URL with sessionId (likely navigating to existing session)
                    const isNavigatingToExistingSession = searchParams.get('sessionId') === sessionIdParam;

                    if (isNavigatingToExistingSession) {
                        // User navigated to a specific sessionId but it has no data
                        // Could be new session or error - treat as empty state, not error
                        setHasSessionDataError(false);
                    } else {
                        // Unexpected state - show error
                        setHasSessionDataError(true);
                    }
                }
                setIsNewSession(false);
            }
        };

        if (searchParams.get('query') === 'get' && searchParams.get('sessionId') && searchParams.get('designSystem')) {
            setIsNewSession(false);
            fetchMessages();
        } else {
            setIniitialFiles(defaultInitialFiles);
            setIsNewSession(false);
            if (thread.length > 0) {
                fetchMessages();
            }
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    // Note: This effect handles URL params on mount - setter functions from context are stable

    useEffect(() => {
        window.addEventListener('message', handleReceiveMessage);
        return () => {
            window.removeEventListener('message', handleReceiveMessage);
            abortActiveStream();
            setStreamMessagesConsumer([]);
            setStreamMessageProvider([]);
            setCurrentChatSessionId(-1);
            setShowCodeStream(false);
            setGenerationStatus(null);
            setModificationOptions(EmptyModificationOptions);
            setIsGenerateComplete(true);
            setIsTargetActive(false);
            setCurrentSource({});
            setCurrentGenerationId('');
            setToolStatus(null);
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    // Note: handleReceiveMessage and setter functions from context are stable

    useEffect(() => {
        if (!isSandboxLoading && !isNewSession) {
            setIsTargetButtonEnabled(true);
        } else {
            setIsTargetActive(false);
        }
    }, [isSandboxLoading, isNewSession]); // eslint-disable-line react-hooks/exhaustive-deps
    // Note: setIsTargetActive is a stable setter function from context

    useEffect(() => {
        if (showCodeStream) {
            setDevModeActive(false);
            setIsTargetActive(false);
            setEnableFullScreen(false);
        }
    }, [showCodeStream]); // eslint-disable-line react-hooks/exhaustive-deps
    // Note: Setter functions from context are stable

    // Clear generation error when a new generation starts
    useEffect(() => {
        if (!isGenerateComplete && generationError) {
            setGenerationError(null);
        }
    }, [isGenerateComplete]); // eslint-disable-line react-hooks/exhaustive-deps
    // Note: generationError is intentionally excluded - checking isGenerateComplete is sufficient

    // Disable target button if user attaches a file to the next prompt
    useEffect(() => {
        if (attachFile) {
            setIsTargetButtonEnabled(false);
            setIsTargetActive(false);
            setModificationOptions({
                componentType: '',
                dataComponentFile: '',
                dataComponentStartLine: '',
                dataComponentName: '',
                elementContent: '',
                elementOuterHTML: '',
                elementTagName: '',
            });
            if (selectedElemRef && selectedElemRef.current) {
                toggleStyle(selectedElemRef.current, false);
            }
        } else if (!attachFile && !isSandboxLoading && !isNewSession) {
            setIsTargetButtonEnabled(true);
        }
    }, [attachFile]); // eslint-disable-line react-hooks/exhaustive-deps
    // Note: Setter functions from context are stable - intentionally checking attachFile changes only

    useEffect(() => {
        const onKey = (e: KeyboardEvent) => {
            const t = e.target as HTMLElement;
            if (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.isContentEditable) {
                return;
            }
            if (e.key.toLowerCase() === 'f' && enableFullScreen) {
                e.preventDefault();
                handleFullScreen();
            }
        };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [enableFullScreen]);

    const toggleStyle = (current: HTMLElement, toggle: boolean) => {
        if (!current) return;
        if (toggle) {
            current.style.background = 'rgba(0, 137, 235, 0.24)';
            current.style.boxShadow = 'inset 0 0 0 1px #0089EB';
            current.style.borderRadius = '4px';
            current.style.cursor = 'pointer';
        } else {
            current.style.background = '';
            current.style.border = '';
            current.style.borderRadius = '';
            current.style.boxShadow = '';
        }
    };

    const handleDownloadSelect = (value: any) => {
        if (currentChatSessionId === -1) return;

        if (value === 'cursor') {
            setCursorInstructionsVisible(true);
            return;
        }

        getDownloadUrl(currentChatSessionId).then((response) => {
            if (response.status === 'SUCCESS') {
                const downloadUrl = response.resultObject;
                const link = document.createElement('a');
                if (value === 'code') {
                    link.href = downloadUrl;
                    link.download = ''; // Optionally set a default filename
                }

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        });
    };

    const generateCursorPrompt = (url: string): string => {
        return `Call the download_and_setup tool with:
        - blobUrl: "${url}"
        - autoStart: true`;
    };

    const generateCursorDeeplink = (projectDir: string): string => {
        // Generate a Cursor deeplink that opens the project directory directly
        // Ensure projectDir starts with / for proper deeplink format
        const normalizedProjectDir = projectDir.startsWith('/') ? projectDir : `/${projectDir}`;
        return `cursor://file${normalizedProjectDir}`;
    };

    const copyToClipboard = async (text: string): Promise<boolean> => {
        try {
            await navigator.clipboard.writeText(text);
            return true;
        } catch (err) {
            console.error('Failed to copy to clipboard:', err);
            return false;
        }
    };

    const handleSelectDevMode = () => {
        // if (!devModeActive) {
        //     setShowCodeStream(false);
        //     setIsTargetActive(false);
        //     setIsTargetButtonEnabled(false);
        // } else {
        //     setIsTargetButtonEnabled(true);
        // }
        setDevModeActive((prev) => {
            const newValue = !prev;
            return newValue;
        });
        // console.log('devModeActive 2', devModeActive);
        // setShowCodeEditor(!showCodeEditor);
    };

    const handleTargetActivate = () => {
        const action = !isTargetActive ? 'openSelect' : 'closeSelect';
        const iframe: any = document.querySelector('iframe');
        if (iframe) {
            console.log(iframe);
            iframe.contentWindow.postMessage({ action, type: 'rc' }, SANDBOX_BUNDLER_URL);
        }
        if (isTargetActive) {
            setModificationOptions(EmptyModificationOptions);
        }
        setIsTargetActive(!isTargetActive);
    };

    const handleShareWithUser = () => {
        setShareModalVisible(true);
    };

    const handleFullScreen = async () => {
        const elem = document.getElementsByClassName('sandbox-container')[0] as HTMLElement | undefined;
        if (!elem) return;

        if (!document.fullscreenElement) {
            await elem.requestFullscreen();
            // Move focus to the Sandpack preview iframe so keyboard input works
            // without requiring a manual click inside the maximized window.
            const iframe = elem.querySelector('iframe') as HTMLIFrameElement | null;
            if (iframe) {
                requestAnimationFrame(() => iframe.focus());
            }
        } else {
            await document.exitFullscreen();
        }
    };

    const handleShareModalCancel = () => {
        setShareModalVisible(false);
    };

    const handleRemoveUserModalCancel = () => {
        setRemoveUserModalVisible(false);
        setUserRemove({} as ShareUser);
        setShareModalVisible(true);
    };

    const handleCursorInstructionsCancel = () => {
        setCursorInstructionsVisible(false);
    };

    const handleRemoveUserConfirm = (user: any) => {
        // remove user
        setRemoveUserModalVisible(false);
        setUserRemove(user);
        setShareModalVisible(true);
    };

    // const renderSettings = () => {
    //     return (
    //         <>
    //             <div className={styles['setting-title']}>
    //                 <span>Theme</span>
    //             </div>
    //             <div className={styles.wrapper}>
    //                 {themes.map((theme, index) => (
    //                     <div
    //                         className={clsx(styles.circle, index === activeTheme && styles.checkmark)}
    //                         key={index}
    //                         style={{ ...theme }}
    //                         onClick={() => setActiveTheme(index)}
    //                     />
    //                 ))}
    //             </div>
    //             <div className={styles['setting-title']}>
    //                 <span>Designs</span>
    //             </div>
    //             <div className={styles.wrapper}>
    //                 <Checkbox defaultChecked className={styles.checkbox}>
    //                     Generate four designs?
    //                 </Checkbox>
    //             </div>
    //         </>
    //     );
    // };

    // Auto-fix handler for Sandpack errors
    const handleAutoFixRequest = useCallback(
        (prompt: string, attemptNumber: number, isRetryingOriginal: boolean) => {
            console.log(
                `Auto-fix requested (attempt ${attemptNumber}, retrying original: ${isRetryingOriginal}):`,
                prompt
            );
            // Trigger the auto-fix through Chat component via shared context
            setAutoFixPrompt({ prompt, attemptNumber, isRetryingOriginal });
        },
        [setAutoFixPrompt]
    );

    const renderedSandbox = useMemo(() => {
        const sourceFiles =
            currentSource &&
            currentSource.payload &&
            currentSource.payload.files &&
            Object.keys(currentSource.payload.files).length !== 0
                ? currentSource.payload.files
                : initialFiles;
        // console.log('memo currentSource', currentSource);
        // console.log(
        //     'key length',
        //     currentSource &&
        //         currentSource.payload &&
        //         currentSource.payload.files &&
        //         Object.keys(currentSource.payload.files).length !== 0
        // );
        return Object.keys(currentSource).length !== 0 ? (
            <EnhancedSandpackRenderer
                // className={
                //     isNewSession || devModeActive
                //         ? styles['hide-current-source']
                //         : styles['show-current-source']
                // }
                //template={template}
                files={sourceFiles}
                dependencies={DepsMap[designSystem]}
                isOptionSource={false}
                showNavigator={true}
                onAutoFixRequest={handleAutoFixRequest}
                maxAutoFixAttempts={3}
                initialPrompt={firstPrompt}
                isInitialGeneration={thread.length <= 1}
            />
        ) : (
            ''
        );
    }, [JSON.stringify(currentSource), initialFiles, handleAutoFixRequest, firstPrompt, thread.length]); // eslint-disable-line react-hooks/exhaustive-deps
    // Note: Using JSON.stringify for complex object memoization - currentSource and designSystem intentionally handled this way
    return (
        <div className={styles.session}>
            <div className={styles['title-bar']}>
                <div className={styles['left-section']}>
                    <Tooltip
                        trigger="hover"
                        position="bottom"
                        distance={4}
                        id="resize-control"
                        content={isChatCollapsed ? 'Expand' : 'Collapse'}>
                        <Button
                            aria-label="Chat toggle button"
                            kind="tertiary"
                            icon={isChatCollapsed ? 'icon-enter-right-outline' : 'icon-enter-left-outline'}
                            onClick={() => setIsChatCollapsed(!isChatCollapsed)}
                        />
                    </Tooltip>
                    <h2>{showCodeStream ? 'Generating...' : 'Preview'}</h2>
                </div>
                <div className={styles['right-section']}>
                    <Tooltip trigger="hover" position="bottom" distance={4} id="select-to-dev-mode" content="Dev Mode">
                        <Button
                            kind={devModeActive ? 'primary' : 'text'}
                            icon="icon-query-outline"
                            onClick={handleSelectDevMode}
                            aria-label="Design element target button"
                            disabled={!isSessionOwner}
                        />
                    </Tooltip>
                    <Tooltip
                        trigger="hover"
                        position="bottom"
                        distance={4}
                        id="select-to-revise-control"
                        content="Select to revise">
                        <Button
                            kind={isTargetActive ? 'primary' : 'text'}
                            icon="icon-center-map-outline"
                            onClick={handleTargetActivate}
                            disabled={!isTargetButtonEnabled || !isSessionOwner}
                            aria-label="Design element target button"
                        />
                    </Tooltip>
                    <Tooltip trigger="hover" position="bottom" distance={4} id="download-control" content="Download">
                        <DropdownButton
                            ariaLabel="Download menu button"
                            className={styles['download-button']}
                            kind="text"
                            onSelect={handleDownloadSelect}
                            disabled={currentChatSessionId === -1}
                            data={[
                                // { label: 'Open in Figma', value: 'figma' },
                                { label: 'Download code', value: 'code' },
                                ...(window.location.hostname === 'localhost' ||
                                window.location.hostname.includes('designdraft.dev.pwc.com')
                                    ? [{ label: 'Open in Cursor', value: 'cursor' }]
                                    : []),
                            ]}>
                            <span className="Appkit4-icon icon-download-cloud-outline" />
                        </DropdownButton>
                    </Tooltip>
                    <Tooltip trigger="hover" position="bottom" distance={4} id="share-control" content="Share">
                        <Button
                            kind={'text'}
                            icon="icon-share-outline"
                            onClick={handleShareWithUser}
                            aria-label="Share button"
                            disabled={!isSessionOwner}
                        />
                    </Tooltip>
                    <Tooltip
                        trigger="hover"
                        position="bottom"
                        distance={4}
                        id="fullscreen-control"
                        content="Full screen">
                        <Button
                            kind={'text'}
                            icon="icon-expand-outline"
                            onClick={handleFullScreen}
                            aria-label="Full screen button"
                            disabled={!enableFullScreen}
                        />
                    </Tooltip>
                    <Tooltip trigger="hover" position="bottom" distance={4} id="settings-control" content="Settings">
                        {/* <PanelButton
                            ariaLabel="Settings panel button"
                            kind="text"
                            icon="icon-setting-outline"
                            popupContent={renderSettings()}
                            popupClassName={styles.settings}
                        /> */}
                    </Tooltip>
                    {/* <Tooltip
                        trigger="hover"
                        position="bottom"
                        distance={4}
                        id="share-with-user-control"
                        content="Share with user">
                        <Button
                            aria-label="Share with user"
                            kind="text"
                            icon="icon-network-outline"
                            onClick={handleShareWithUser}
                        />
                    </Tooltip> */}
                </div>
            </div>
            <div className={styles['session-body']}>
                {isNewSession && (
                    <>
                        <NoDataSet />
                        <h3>Start your new design</h3>
                        <p>Enter a prompt or upload a file to begin</p>
                        <div className={styles.tip}>
                            <span className="Appkit4-icon icon-lightbulb-outline" />
                            <p>
                                Select a specific prompt in the conversation window to switch between generated design
                                versions.
                            </p>
                        </div>
                    </>
                )}

                {hasSessionDataError && !isNewSession && (
                    <EmptySessionError
                        sessionId={sessionId}
                        onRetryWithPrompt={(prompt) => {
                            // User wants to retry generation with original prompt
                            setHasSessionDataError(false);
                            setIsNewSession(false);

                            // Set the first prompt so generation can start
                            setFirstPrompt(prompt);

                            // Clear the stored prompt (it will be re-stored if needed)
                            const storedPromptKey = `rapidcraft-prompt-${sessionId}`;
                            localStorage.removeItem(storedPromptKey);

                            console.log('Retrying generation with prompt:', prompt);
                        }}
                        onDismiss={() => {
                            setHasSessionDataError(false);
                            // Clear the stored prompt
                            const storedPromptKey = `rapidcraft-prompt-${sessionId}`;
                            localStorage.removeItem(storedPromptKey);
                        }}
                    />
                )}

                {generationError && !hasSessionDataError && (
                    <GenerationErrorOverlay
                        message={generationError.message}
                        error={generationError.error}
                        prompt={generationError.prompt}
                        onRetry={() => {
                            // Clear the error state
                            setGenerationError(null);

                            // Retry generation with the same prompt
                            setFirstPrompt(generationError.prompt);

                            console.log('Retrying generation after error:', generationError.prompt);
                        }}
                        onDismiss={() => {
                            // Clear the error state
                            setGenerationError(null);
                        }}
                    />
                )}

                {/* {devModeActive && (
                    <CodeEditor
                        files={currentSource && currentSource.payload ? currentSource.payload.files : initialFiles}
                    />
                )} */}
                {/* <div className={`sandbox-renderer-container ${devModeActive ? 'hide' : 'show'}`}> */}
                {!hasSessionDataError && (
                    <div className={`sandbox-renderer-container`}>
                        <div className="sandbox-container">
                            {/* {sandpackErrors ? <ErrorSandpack /> : renderedSandbox} */}
                            {renderedSandbox}
                        </div>
                        <GeneratingOverlay visible={showCodeStream} statusMessage={generationStatus} />
                        <div className={`sandbox-loading ${isSandboxLoading ? 'loading' : 'hide'}`}>
                            <Loading indeterminate />
                        </div>
                    </div>
                )}
            </div>
            {shareModalVisible && (
                <ShareModal
                    visible={shareModalVisible}
                    title="Share project"
                    onCancel={handleShareModalCancel}
                    modalStyle={{ width: '500px' }}
                    activeSessionId={sessionId}></ShareModal>
            )}
            {removeUserModalVisible && (
                <RemoveUserModal
                    visible={removeUserModalVisible}
                    title="Remove user?"
                    onCancel={handleRemoveUserModalCancel}
                    onRemoveConfirm={(user: any) => handleRemoveUserConfirm(user)}
                    modalStyle={{ width: '540px' }}
                    userRemove={userRemove}></RemoveUserModal>
            )}
            {cursorInstructionsVisible && (
                <CursorInstructionsModal
                    visible={cursorInstructionsVisible}
                    onCancel={handleCursorInstructionsCancel}
                    onOpenInCursor={(projectDir: string) => {
                        setCursorInstructionsVisible(false);
                        if (currentChatSessionId !== -1 && projectDir.trim()) {
                            getDownloadUrl(currentChatSessionId).then(async (response) => {
                                if (response.status === 'SUCCESS') {
                                    const downloadUrl = response.resultObject;

                                    const cursorPrompt = generateCursorPrompt(downloadUrl);
                                    const promptSuccess = await copyToClipboard(cursorPrompt);
                                    if (promptSuccess) {
                                        console.log('Cursor prompt copied to clipboard:', cursorPrompt);
                                    }

                                    const cursorDeeplink = generateCursorDeeplink(projectDir.trim());
                                    window.open(cursorDeeplink, '_blank');
                                }
                            });
                        }
                    }}
                />
            )}
            {/* <LeaveConfirm></LeaveConfirm> */}
            <div className={styles['ap-field-alert']}>
                AI-generated content may be inaccurate and requires human review.{' '}
                <a
                    className="ap-link"
                    href="https://hq.pwc.com/content/hq/en/our-clients-and-business/delivering-one-firm-to-clients/artificial-intelligence-at-pwc/business-rules-for-use-of-generative-ai.html"
                    target="_blank">
                    GenAI
                </a>{' '}
                Business Rules.
            </div>
        </div>
    );
};

export default Session;
